const updates = [
  {
    date: '07-31',
    title: '《星际迷途：新纪元》高清片源已上线',
    desc: '年度最受期待的科幻巨制现已加入片库，支持蓝光画质流畅播放。',
  },
  {
    date: '07-30',
    title: '暑期动画特辑全面更新',
    desc: '新增15部国内外高分动画电影，涵盖奇幻冒险、治愈日常等多种风格。',
  },
  {
    date: '07-29',
    title: '经典港片修复版上线',
    desc: '十部黄金年代港产经典影片以修复画质回归，重温光影记忆。',
  },
  {
    date: '07-28',
    title: '悬疑推理专题周开启',
    desc: '精选20部烧脑悬疑佳作，从日式本格推理到欧美心理惊悚一网打尽。',
  },
  {
    date: '07-27',
    title: '播放体验全面优化升级',
    desc: '服务器扩容完成，全站视频加载速度提升40%，真正实现不缓冲观影。',
  },
  {
    date: '07-26',
    title: '纪录片频道新增自然系列',
    desc: 'BBC和Discovery经典自然纪录片高清合辑已上线，探索地球脉动之美。',
  },
  {
    date: '07-25',
    title: '热门电影下载功能即将推出',
    desc: '为方便移动观影，离线缓存功能正在测试中，敬请期待上线通知。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            555影视每日动态，不错过每一部新上线的好电影
          </p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-3.5 top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-8">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[1.65rem] md:-left-[1.85rem] top-1 w-3 h-3 rounded-full border-2 border-primary-500 bg-background-50"></div>
                <div>
                  <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                    {item.date}
                  </span>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}